import _ from 'lodash';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import i18next from 'i18next';
import CalculatorMultipleSelectInput from '../../../../calculatorInputs/CalculatorMultipleSelectInput';
import CalculatorMultipleValueInput from '../../../../calculatorInputs/CalculatorMultipleValueInput';

const SetValue = ({ fieldName, showLabel, availableValueOptions, readOnly = false }) => {
  const { setError, clearErrors } = useFormContext();

  const label = showLabel ? i18next.t('calculator.dialog.create.label.values') : '';
  const placeholder = i18next.t('calculator.dialog.create.placeholder.selectValues');

  const validate = (value) => {
    if (!value || value.length === 0) {
      setError(fieldName, {
        type: 'manual',
        message: i18next.t('calculator.errors.criterionValueEmpty'),
      });
      return false;
    }
    clearErrors(fieldName);
    return true;
  };

  const commonProps = {
    fieldName,
    label,
    placeholder,
    isRequired: true,
    uxVariant: 'criteriaInput',
    validate,
  };

  const hasOptions = !_.isEmpty(availableValueOptions);

  return hasOptions ? (
    <CalculatorMultipleSelectInput
      {...commonProps}
      options={availableValueOptions}
      variant="standard"
      triggerOnContinue
      disabled={readOnly}
    />
  ) : (
    <CalculatorMultipleValueInput {...commonProps} triggerOnContinue disabled={readOnly}/>
  );
};

export default SetValue;
